var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTwotoneRunningWithErrors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5V13.5H15V7.5H16.5ZM15 15V16.5H16.5V15H15ZM13.5 12.9675C12.9374 13.6065 12.245 14.1183 11.4691 14.4688C10.6931 14.8192 9.85142 15.0003 9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3V9.75L14.6625 4.0875C13.9601 3.27456 13.0907 2.6226 12.1135 2.17608C11.1363 1.72955 10.0744 1.49896 9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C10.6875 16.5 12.2475 15.945 13.5 15V12.9675Z",
    fill: "#71758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwotoneRunningWithErrors);
export default __webpack_public_path__ + "static/media/ic_twotone-running-with-errors.2c7c40d878e4c32ac2aae59b0a58ab3e.svg";
export { ForwardRef as ReactComponent };